import { fetchUtils } from '../utils/fetchUtils';

export const uploadJob = (data) => fetchUtils.post('/api/job/upload', data);
export const getJobs = (params) => fetchUtils.get('/api/job', params);
export const getAllJobs = (params) => fetchUtils.get('/api/job/all', params);
export const getJobById = (id) => fetchUtils.get(`/api/job/${id}`);
export const updateJobById = (id,data) => fetchUtils.put(`/api/job/${id}`,data);
export const deleteJobById = (id) => fetchUtils.delete(`/api/job/${id}`);
export const deleteAllJobs = () => fetchUtils.delete('/api/job/all');
